import { Dropdown } from "@iq/models";
import { TIME_RANGE_PRESETS } from "../../states/useAdminTimeClockStore";

const PRESET_LABELS = {
	today: "Today",
	this_week: "This Week",
	last_7_days: "Last 7 Days",
	last_30_days: "Last 30 Days",
	custom: "Custom",
};

function TimeClockFilters({ filters, teamMembers, loading, onFilterChange, onApply }) {
	const members = Array.isArray(teamMembers) ? teamMembers : [];
	const selectedPresetLabel = PRESET_LABELS[filters.preset] || filters.preset;
	const selectedUserLabel =
		filters.userId === "all"
			? "All Employees"
			: members.find((member) => String(member?.id) === String(filters.userId))?.name ||
			  members.find((member) => String(member?.id) === String(filters.userId))?.email ||
			  "All Employees";

	return (
		<section className="admin-time-clock-card admin-time-clock-filters" aria-label="Time clock filters">
			<div className="admin-time-clock-filter-grid">
				<label>
					<span>Range</span>
					<Dropdown
						id="admin-time-clock-range"
						name="admin-time-clock-range"
						placeholder="Select range"
						value={selectedPresetLabel}
						onInputChange={() => {}}
						allowCustom={false}
						colorScheme="light"
						ariaLabel="Time clock range"
						renderInPortal
						disabled={loading}
					>
						{({ closeMenu }) => (
							<>
								{TIME_RANGE_PRESETS.map((preset) => (
									<button
										key={preset}
										type="button"
										className="dropdown-menu-item"
										onClick={() => {
											onFilterChange("preset", preset);
											closeMenu();
										}}
									>
										{PRESET_LABELS[preset] || preset}
									</button>
								))}
							</>
						)}
					</Dropdown>
				</label>

				<label>
					<span>Employee</span>
					<Dropdown
						id="admin-time-clock-user"
						name="admin-time-clock-user"
						placeholder="All Employees"
						value={selectedUserLabel}
						onInputChange={() => {}}
						allowCustom={false}
						colorScheme="light"
						ariaLabel="Employee filter"
						renderInPortal
						disabled={loading}
					>
						{({ closeMenu }) => (
							<>
								<button
									type="button"
									className="dropdown-menu-item"
									onClick={() => {
										onFilterChange("userId", "all");
										closeMenu();
									}}
								>
									All Employees
								</button>
								{members.map((member) => (
									<button
										key={member.id}
										type="button"
										className="dropdown-menu-item"
										onClick={() => {
											onFilterChange("userId", String(member.id));
											closeMenu();
										}}
									>
										{member.name || member.email}
									</button>
								))}
								{members.length === 0 ? <div className="dropdown-menu-empty">No employees found</div> : null}
							</>
						)}
					</Dropdown>
				</label>

				<label>
					<span>Focus Day</span>
					<input
						type="date"
						value={filters.focusDate}
						onChange={(event) => onFilterChange("focusDate", event.target.value)}
						disabled={loading}
					/>
				</label>

				{filters.preset === "custom" ? (
					<>
						<label>
							<span>From</span>
							<input
								type="date"
								value={filters.customFrom}
								onChange={(event) => onFilterChange("customFrom", event.target.value)}
								disabled={loading}
							/>
						</label>
						<label>
							<span>To</span>
							<input
								type="date"
								value={filters.customTo}
								onChange={(event) => onFilterChange("customTo", event.target.value)}
								disabled={loading}
							/>
						</label>
					</>
				) : null}
			</div>

			<div className="admin-time-clock-filter-actions">
				<button type="button" onClick={onApply} disabled={loading}>
					{loading ? "Loading..." : "Apply Filters"}
				</button>
			</div>
		</section>
	);
}

export default TimeClockFilters;
